//
// Copyright 2023 DXOS.org
//

export const mainPaddingTransitions = 'dx-main-content-padding-transitions';
export const mainIntrinsicSize = 'dx-main-intrinsic-size';
